import { ICountryWithCluster } from 'onboarding/classes/models/partnerTerritoryModels'

export const getSerializedNamesByCodes = (
  selectedCountryCodes: string,
  countries: ICountryWithCluster[]
) => {
  const result: string[] = []
  const selectedCountries = selectedCountryCodes ? selectedCountryCodes.split(',') : []
  selectedCountries.map((selectedCountry: string) => {
    const foundCountry = countries.find((country) => country.value === selectedCountry)
    if (foundCountry) result.push(foundCountry.name)
  })

  return result.join(', ')
}
